export const lob_publishable_api_key_test = 'test_pub_bbe83a4d044a901ebc877d533588275';
export const lob_publishable_api_key_live = 'live_pub_773d413d9879a8ba09f071a0cc996cf';
